import UpdateDeviceModal from "./device-modal.component";

export default UpdateDeviceModal;
